import React from 'react';
import { Grid } from '@mui/material';

import { Divider, InfoField } from '@occc/ui-design-system';
import { SiteManagementLocationFragment } from '@occc/graphql';

interface LocationAddressDetailsProps {
  data: SiteManagementLocationFragment | null;
}

export const LocationAddressDetails: React.FC<LocationAddressDetailsProps> = ({ data }) => {
  return (
    <>
      <Grid container spacing={2} pb={1}>
        <Grid item xs={12} sm={3}>
          <InfoField label='Site Name' value={data?.name} />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoField label='Street 1' value={data?.address?.street1} />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoField label='Street 2' value={data?.address?.street2} />
        </Grid>
      </Grid>

      <Divider />

      <Grid container spacing={2} pb={1} pt={3}>
        <Grid item xs={12} sm={3}>
          <InfoField label='City' value={data?.address?.city} />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoField label='State' value={data?.address?.state} />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoField label='Zip Code' value={data?.address?.zipCode} />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoField label='Country' value={data?.address?.countryCode} />
        </Grid>
      </Grid>

      <Divider />

      <Grid container spacing={2} pb={1} pt={3}>
        <Grid item xs={12} sm={3}>
          <InfoField label='Latitude' value={data?.address?.geoLocation?.latitude} />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoField label='Longitude' value={data?.address?.geoLocation?.longitude} />
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoField label='Timezone' value={data?.timezone} />
        </Grid>
      </Grid>
    </>
  );
};
